/** The org's default password, assigned to every new account. */
const DEFAULT_PASSWORD = "protec8";

/**
 * Words a new password must not contain — references to the org, its diplomas, or its systems,
 * all too easy to guess for a Timeline account.
 */
const PASSWORD_BANNED_KEYWORDS = [
  "protec",
  "secour", // couvre "secours" et "secouriste"
  "pcps",
  "pcp8",
  "pcp9",
  "pcp89",
  "paris8",
  "paris9",
  "protectioncivile",
  "civile",
  "timeline",
  "psc1",
  "pse1",
  "pse2",
];

export interface PasswordRequirement {
  label: string;
  test: (password: string) => boolean;
}

/** The org's minimum password-strength policy, in display order. */
export const PASSWORD_REQUIREMENTS: PasswordRequirement[] = [
  { label: "Au moins 8 caractères", test: (password) => password.length >= 8 },
  { label: "Au moins 1 chiffre", test: (password) => /\d/.test(password) },
  {
    label: "Au moins 1 caractère spécial",
    test: (password) => /[^a-zA-Z0-9]/.test(password),
  },
  {
    label: `Ne doit pas être le mot de passe par défaut (${DEFAULT_PASSWORD})`,
    test: (password) => !password.toLowerCase().includes(DEFAULT_PASSWORD),
  },
  {
    label: "Ne doit pas contenir de mot interdit (protec, secours, pcp8...)",
    test: (password) => {
      const lowered = password.toLowerCase();
      return !PASSWORD_BANNED_KEYWORDS.some((keyword) =>
        lowered.includes(keyword)
      );
    },
  },
];

/** Labels of the unmet requirements for a password — empty when it's strong enough. */
export const getPasswordStrengthErrors = (password: string): string[] =>
  PASSWORD_REQUIREMENTS.filter(
    (requirement) => !requirement.test(password)
  ).map((requirement) => requirement.label);

export const isPasswordStrong = (password: string): boolean =>
  getPasswordStrengthErrors(password).length === 0;
